import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: 'theme-1'
  },
  mutations: {
    setTheme: (state, payload) => {
      state.theme = payload;
    }
  },
  getters: {
    getTheme: (state) => {
      return state.theme;
    },
  },
  actions: {
    changeTheme: ({ state, commit }) => {
      if(state.theme == 'theme-1') {
        commit('setTheme', 'theme-2')
      } else {
        commit('setTheme', 'theme-1')
      }
    },
    setTheme: ({commit }, payload) => {
      commit('setTheme', payload)
    }
  },
  modules: {
  }
})
